export default __webpack_public_path__ + "static/media/unhallowedblight4.038cdb31.png";